import '@aws-amplify/ui-react/styles.css';
import '@fontsource/poppins/100.css';
import '@fontsource/poppins/200.css';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/800.css';
import '@fontsource/poppins/900.css';
import { Box, Container } from '@mui/material';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import HomePatients from './components/HomePatients.tsx';
import NavigationBar from './components/NavigationBar.tsx';
import Profile from './components/Profile.tsx';
import Activity from './components/admin/Activity.tsx';
import HealthProfessional from './components/admin/HealthProfessional.tsx';
import Hospitals from './components/admin/Hospitals.tsx';
import Patients from './components/admin/Patients.tsx';
import Studies from './components/admin/Studies.tsx';
import PatientDashboard from './components/patient/Dashboard/PatientDashboard.tsx';
import PatientCompleteWizard from './components/patient/PatientCompleteWizard.tsx';
import PatientInfo from './components/patient/PatientInfo.tsx';
import PatientInfoNewVisit from './components/patient/PatientInfoNewVisit.tsx';
import PatientInitWizard from './components/patient/PatientInitWizard.tsx';
import PrivateRouteWithRole from './routes/PrivateRouteWithRole.tsx';

const AuthenticatedApp = () => {
  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Router>
        {/* Navigation Bar */}
        <Box width="100%">
          <NavigationBar />
        </Box>

        {/* Main Content Area */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
          }}
        >
          <Container
            maxWidth={false}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1, // Allow the Container to grow
              padding: 2,
              overflow: 'auto',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1, // Allow Routes to grow
              }}
            >
              <Routes>
                <Route element={<PrivateRouteWithRole element={<PatientInitWizard />} roles={['doctor', 'arc']} />} path="/patient/init" />
                <Route element={<PrivateRouteWithRole element={<PatientInfo />} roles={['doctor', 'arc', 'admin']} />} path="/patient/:id/view/:tab" />
                <Route element={<PrivateRouteWithRole element={<PatientCompleteWizard />} roles={['doctor', 'arc']} />} path="/patient/:id/complete" />
                <Route element={<PrivateRouteWithRole element={<PatientCompleteWizard />} roles={['doctor', 'arc']} />} path="/patient/:id/complete/:step" />
                <Route element={<PrivateRouteWithRole element={<PatientInfoNewVisit />} roles={['doctor', 'arc', 'admin']} />} path="/patient/:id/new-visit" />
                <Route element={<PrivateRouteWithRole element={<PatientDashboard />} roles={['admin']} />} path="/patient/:id/dashboard/:tab" />
                <Route element={<PrivateRouteWithRole element={<Hospitals />} roles={['admin']} />} path="/admin/hospitals" />
                <Route element={<PrivateRouteWithRole element={<Studies />} roles={['admin']} />} path="/admin/studies" />
                <Route element={<PrivateRouteWithRole element={<Patients />} roles={['admin']} />} path="/admin/patients" />
                <Route element={<PrivateRouteWithRole element={<HealthProfessional />} roles={['admin']} />} path="/admin/health-professionals" />
                <Route element={<PrivateRouteWithRole element={<Activity />} roles={['admin']} />} path="/admin/activity" />
                <Route element={<PrivateRouteWithRole element={<HomePatients />} roles={['doctor', 'arc']} />} path="/patients" />
                <Route element={<Profile />} path="/profile" />
                <Route element={<HomePatients />} path="*" />
              </Routes>
            </Box>
          </Container>
        </Box>
      </Router>
    </Box>
  );
};

export default AuthenticatedApp;
